import { Stack } from '@mui/material';

import { CloseButton } from '@/components/form/baseInputs/Button/CloseButton';
import { useDocumentChatContext } from '@/modules/chat/contexts/DocumentChatProvider';
import { COLORS } from '@/styles/tokens/colors';

import { CHAT_WIDTH } from '../../common/Chat/ChatPane/Chat.constants';
import { DocumentChatHeader } from './DocumentChatHeader';
import { DocumentChatShell } from './DocumentChatShell';

export interface DocumentChatPanelProps {
  enableCopyCitationPopover?: boolean;
}

export function DocumentChatPanel({
  enableCopyCitationPopover = false,
}: DocumentChatPanelProps) {
  const { closeChat } = useDocumentChatContext();

  return (
    <DocumentChatShell
      header={
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            px: 2,
            py: 1,
            borderBottom: `solid 1px ${COLORS.GRAY[200]}`,
          }}
        >
          <DocumentChatHeader />
          <CloseButton size="sm" variant="transparent" onClick={closeChat} />
        </Stack>
      }
      enableCopyCitationPopover={enableCopyCitationPopover}
      sx={{
        minWidth: `${CHAT_WIDTH}px !important`,
        width: `${CHAT_WIDTH}px`,
        borderLeft: `solid 1px ${COLORS.GRAY[200]}`,
      }}
    />
  );
}
